import { inject, injectable } from "inversify";
import TYPES from "../ioc/types";
import { GameStateDTO, PlayerCharacterDTO } from "../shared/dtos";
import { SocketEvents } from "../shared/enum";
import { DefaultEventService } from "./event-service";

export interface GameStateService {
    players: Array<PlayerCharacterDTO>;

    // redundant with players & gold etc., remove some or the other somewhen
    gameState: GameStateDTO;

    gold: number;

    refresh();

    saveCharacterPosition();
}

@injectable()
export class DefaultGameStateService implements GameStateService {
    private _players: Array<PlayerCharacterDTO> = [];

    private _gameState: GameStateDTO;

    public loadComplete: boolean;

    constructor(@inject(TYPES.EventService) private eventService: DefaultEventService) {
        this.eventService.register(SocketEvents.REFRESH_GAME_STATE, (data) =>
            this.onRefreshGameState(data)
        );
    }

    public onRefreshGameState(data) {
        const gameState = JSON.parse(data) as GameStateDTO;
        this.gameState = gameState;
    }

    public refresh() {
        this.eventService.emit(SocketEvents.REFRESH_GAME_STATE_REQUEST);
    }

    public saveCharacterPosition() {
        // Backend validates save via session (set during load_game_request), not parameter
        this.eventService.emit(
            SocketEvents.SAVE_CHARACTER_POSITION,
            this._gameState.game_location.scene_id,
            this._gameState.game_location.x,
            this._gameState.game_location.y,
            this._gameState.player_direction // Send direction as 4th parameter
        );
    }

    get gold(): number {
        return this.gameState.gold;
    }

    /*    set gold(amount: number) {
        this._gold = amount;
    }*/

    get gameState(): GameStateDTO {
        return this._gameState;
    }

    set gameState(gameState: GameStateDTO) {
        this._gameState = gameState;
    }

    get players(): Array<PlayerCharacterDTO> {
        return this._players;
    }

    set players(players: Array<PlayerCharacterDTO>) {
        this._players = players;
    }
}
